<template>
    <footer class="footer lang" ref="footer">
        <div class="inner">
            <h1 class="logo">
                <a href="">
                    <img src="@/assets/resource/icon/footer-logo-lang--aorta.svg" alt=""  v-if="$store.state.hospStore.hostNm === '대동맥혈관병원'">
                    <img src="@/assets/resource/icon/footer-logo-lang--ewhabrain.svg" alt=""  v-if="$store.state.hospStore.hostNm === '뇌혈관병원'">
                    <img src="@/assets/resource/icon/footer-logo-lang--mombaby.svg" alt=""  v-if="$store.state.hospStore.hostNm === '엄마아기병원'">
                    <img src="@/assets/resource/icon/footer-logo-lang--blood.svg" alt=""  v-if="$store.state.hospStore.hostNm === '혈액암병원'">
                </a>
            </h1>
            <div class="footer-con">
                <div class="footer-con__info">
                    <p v-if="$store.state.hospStore.hostNm === '혈액암병원'">
                        (07804) 260, Gonghang-daero, Gangseo-gu, Seoul, Republic of Korea
                        <br>
                        Representative number : +82-2-2650-5890
                        <br>
                        E-Mail : ewha.arab@gmail.com
                        <br>
                        <br>
                        Copyright (c) 2019 Ewha womans university medical center. All rights reserved.
                    </p>
                    <p v-else>
                        (07804) 260, Gonghang-daero, Gangseo-gu, Seoul, Republic of Korea
                        <br>
                        Representative number : +82-2-6986-5895
                        <br>
                        E-Mail : ewha.arab@gmail.com
                        <br>
                        <br>
                        Copyright (c) Ewha Womans University Medical Center. All rights reserved.
                    </p>
                </div>
            </div>
            <div class="footer-link">
                <div class="footer-select" ref="footerSelect2">
                    <a href="javascript:;" class="footer-select--btn" @click.prevent="footer_select2" :class="{ active: footer_option2 }">Family site</a>
                    <slide-up-down :active="footer_option2" class="footer-option">
                        <a v-if="$store.state.hospStore.hostNm === '혈액암병원'" href="https://mokdong.eumc.ac.kr/arbic/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">Mokdong Hospital</a>
                        <a v-if="$store.state.hospStore.hostNm === '혈액암병원'" href="https://seoul.eumc.ac.kr/arbic/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">Seoul Hospital</a>

                        <a v-if="$store.state.hospStore.hostNm !== '혈액암병원'" href="https://seoul.eumc.ac.kr/arbic/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">Seoul Hospital</a>
                        <a v-if="$store.state.hospStore.hostNm !== '혈액암병원'" href="https://mokdong.eumc.ac.kr/arbic/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">Mokdong Hospital</a>

                        <a v-if="$store.state.hospStore.hostNm !== '뇌혈관병원'" href="https://ewhabrain.eumc.ac.kr/ar/main" class="footer-option--btn" target="_blank" title="새 창 열림">Cerebrovascular Hospital</a>
                        <a v-if="$store.state.hospStore.hostNm !== '대동맥혈관병원'" href="https://aorta.eumc.ac.kr/ar/main" class="footer-option--btn" target="_blank" title="새 창 열림">Aorta and Vascular Hospital</a>
                        <a v-if="$store.state.hospStore.hostNm !== '엄마아기병원'" href="https://mombaby.eumc.ac.kr/ar/main" class="footer-option--btn" target="_blank" title="새 창 열림">Mother & Baby Hospital</a>
                        <a href="https://wch.eumc.ac.kr/arbic/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">Cancer Center For Women</a>
                        <a href="https://ewui.eumc.ac.kr/arbic/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">Urology Institute</a>
                        <a v-if="$store.state.hospStore.hostNm !== '혈액암병원'" href="https://blood.eumc.ac.kr/ar/main" class="footer-option--btn" target="_blank" title="새 창 열림">Blood Cancer Hospital</a>
                    </slide-up-down>
                </div>
            </div>
        </div>
    </footer>
    <kr_popup_terms ref="terms"/>
    <kr_popup_patientRight ref="right"/>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
    components: {
        SlideUpDown,
    },
    data() {
        return {
            footer_option1: false,
            footer_option2: false,
        };
    },
    methods: {
        footer_select1() {
            this.footer_option1 = !this.footer_option1;
        },
        footer_select2() {
            this.footer_option2 = !this.footer_option2;
        },
        closeFooterOptions(event) {
            // if(!this.$el.querySelector) return
            const footerSelect1 = this.$refs.footerSelect1;
            const footerSelect2 = this.$refs.footerSelect2;
            if (
                footerSelect1 && !footerSelect1.contains(event.target) &&
                footerSelect2 && !footerSelect2.contains(event.target)
            ) {
                this.footer_option1 = false;
                this.footer_option2 = false;
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.closeFooterOptions);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.closeFooterOptions);
    },
};
</script>
